import { genericFormI } from 'src/app/util/interfaces/genericFormRMK';

export const initBehalfOfForm = (): genericFormI[] => {
	const behalfOfForm: genericFormI[] = [];

	const behalfOfNameFormItem = new genericFormI('string');
	behalfOfNameFormItem.name = 'name';
	behalfOfNameFormItem.label = 'lbl_geral_nome';
	behalfOfForm.push(behalfOfNameFormItem);

	const behalfOfEmailFormItem = new genericFormI('string');
	behalfOfEmailFormItem.name = 'email';
	behalfOfEmailFormItem.label = 'lbl_geral_email';
	behalfOfForm.push(behalfOfEmailFormItem);

	const behalfOfCustomerFormItem = new genericFormI('select');
	behalfOfCustomerFormItem.name = 'customer';
	behalfOfCustomerFormItem.label = 'lbl_geral_cliente';
	behalfOfForm.push(behalfOfCustomerFormItem);

	return behalfOfForm;
};
